import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        sites: '='
    },
    template: `
        <div class="well type02">
            <div class="form">
                <forms-forms-actions-general
                    tags="vm.tags"
                    form="vm.form"
                    sites="vm.sites"
                    repeat-count="vm.repeatCount"
                    is-certification-form="vm.isCertificationForm"
                />
            </div>
        </div>
        <div class="well color02" ng-if="vm.isCertificationForm">
            <h2>{{ 'forms.Display settings' | translate }}</h2>
            <forms-forms-actions-settings-display form="vm.form"/>
        </div>
        <div class="well color02" ng-if="vm.isCertificationForm">
            <h2>{{ 'forms.Questions settings' | translate }}</h2>
            <forms-forms-actions-settings-questions form="vm.form"/>
        </div>
        <div ng-repeat="error in vm.formErrors">
            <p class="alert alert-warn">{{ error }}</p>
        </div>
        <ul class="actions01">
            <li ng-if="vm.canManageForm" class="primary"><a ng-click="vm.update()" class="btn main">{{ 'forms.Save general data' | translate }}</a></li>
            <li ng-if="vm.canManageForm" class="primary"><a ng-click="vm.saveAsNew()" class="btn bordered02">{{ 'forms.Clone form' | translate }}</a></li>
            <li class="primary"><a ng-click="vm.generateSubmission()" class="btn bordered02">{{ 'forms.Display form preview' | translate }}</a></li>
            <li class="primary" ng-if="vm.hasExportSupport()"><a ng-click="vm.exportCsv()" class="btn bordered02">{{ 'forms.Export data dump' | translate }}</a></li>
        </ul>
    `
})

export default class {
    constructor ($state, $rootScope, $translate, $window, lodash, moment, toastr, FORMS_TYPE_ENUM, FormFactory, FormService,
                 TokenService, FormResource, FormSubmissionResource, AuthResource, ModalService) {
        this.$state = $state;
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.$window = $window;
        this.lodash = lodash;
        this.moment = moment;
        this.toastr = toastr;
        this.FORMS_TYPE_ENUM = FORMS_TYPE_ENUM;
        this.FormFactory = FormFactory;
        this.FormService = FormService;
        this.TokenService = TokenService;
        this.FormResource = FormResource;
        this.AuthResource = AuthResource;
        this.FormSubmissionResource = FormSubmissionResource;
        this.ModalService = ModalService;
    }

    $onInit () {
        this.formErrors = [];
        this.repeatCount = this.form.model.repeatCount;
        this.language = this.$translate.use();
        this.tags = [];
        this.isCertificationForm = this.FormService.isCertificationForm(this.form.model);
        this.canManageForm = this.FormService.canManageForm(this.form.model);
    }

    generateSubmission () {
        this.FormSubmissionResource.save({
            name: 'Test submission name',
            email: 'example@opus.ee',
            formId: this.form.model.id,
            userId: this.TokenService.getUser().id
        }).$promise.then((data) => {
            this.$state.go('authorized.forms.submission', { guid: data.guid });
        }).catch((errors) => {
            this.formErrors = errors.data.map((error) => {
                return error.message;
            });
        });
    }

    update () {
        this.$rootScope.$broadcast('set.formSiteIds');
        this.form.model.repeatCount = this.FormService.getRepeatForModel(this.repeatCount);
        this.FormService.finalizeModelBeforeSave(this.form.model);
        this.form.save()
            .then((model) => {
                this.form.model = model;

                if (this.repeatCount === null) {
                    this.repeatCount = this.FORM_REPEAT_ENUM.KEYS.UNLIMITED;
                }
                this.repeatOptions = this.FormService.getRepeatOptions();

                this.form.model.tagsForm = [];

                if (this.form.model.tags) {
                    this.tags = this.lodash.reduce(this.form.model.tags, (result, tag) => {
                        this.form.model.tagsForm.push({ tag: tag.tag });
                        result.push(tag.tag);
                        return result;
                    }, []);
                }
                else {
                    this.tags = [];
                }
                this.toastr.success(this.$translate.instant('forms.Form general data is updated successfully'));
            });
    }


    saveAsNew () {
        this.$rootScope.$broadcast('set.formSiteIds');
        this.FormService.finalizeModelBeforeSave(this.form.model);

        const formToClone = this.form.model;
        return this.ModalService.open({
            template: `
                <modals-forms-clone
                    uib-modal-instance="vm.$uibModalInstance"
                    form="vm.form"
                    class="wrapper"
                />
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.form = formToClone;
            }
        });
    }

    exportCsv () {
        this.AuthResource
            .requestTacToken().$promise
            .then(({ token }) => {
                const qs = `formIds[]=${this.form.model.id}&_lang=${this.language}&to=${this.moment().format('YYYY-MM-DD')}`;
                const url = `${SEED_CORE.ENV.API_URL}form/question/data-dump-export/?tacToken=${token}&${qs}`;
                this.$window.open(url);
            });
    }

    hasExportSupport () {
        return this.form.model.type === this.FORMS_TYPE_ENUM.KEYS.CERTIFICATION || this.form.model.type === this.FORMS_TYPE_ENUM.KEYS.CERTIFICATION_FEEDBACK;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/forms/form/general/index.js